import moment from "moment/moment";

export function getDate(start, end) {
    const dateStart = moment(start).format("D[/]MM");
    const dateEnd = moment(end).format("l");

    return `${dateStart} - ${dateEnd}`;
}